import { IField, IFieldValue } from 'types/graphql'

export type ExtendedField = IField & { fieldLinkId: string; primary: boolean }

export enum RiskNotificationType {
  SetField = 'RISK_RESOLVE_SPECIAL_TYPES',
  StrategySetField = 'STRATEGY_SET_FIELD',
  ShowFunction = 'RISK_RESOLVE_SHOW_FUNCTION_TRANSACTIONS',
  RefetchRelatedForms = 'RISK_REFETCH_RELATED_FORMS',
  FieldValueUpdated = 'FIELD_VALUE_UPDATED'
}

export type IRiskFieldValue = IFieldValue & {
  fieldLinkId?: string
  fieldValueId?: string
  linkedRiskId?: string
  relatedFieldId?: string
  sourceFieldId?: string
  linkedFieldValueId?: string
}
